import { render } from "./agencySlide5.vue?vue&type=template&id=20b5e877&scoped=true"
import script from "./agencySlide5.vue?vue&type=script&lang=js"
export * from "./agencySlide5.vue?vue&type=script&lang=js"

import "./agencySlide5.vue?vue&type=style&index=0&id=20b5e877&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b5e877"]])

export default __exports__